function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import React from 'react';
import ActivityIcon from 'svg/activity.svg';
import InjectionIcon from 'svg/injection.svg';
import MealIcon from 'svg/meal.svg';
import MeasurementIcon from 'svg/measurement.svg';
import NoteIcon from 'svg/note.svg';
import PillsIcon from 'svg/pills.svg';
import tooltipMessages from 'components/RelatedData/messages';
import messages from '../../../../messages';
import RelatedData from './RelatedData';
import Measurement from './Measurement';
export const getTooltipComponent = (tooltipType)=>{
    let TooltipComponent = null;
    switch(tooltipType){
        case 'measurement':
            {
                TooltipComponent = Measurement;
                break;
            }
        case 'related':
            TooltipComponent = RelatedData;
            break;
        default:
            TooltipComponent = null;
    }
    return TooltipComponent;
};
export const getLabel = (element, tooltipType)=>{
    if (tooltipType === 'measurement') {
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.measurement));
    }
    const elementType = element.resourceType || element.type;
    // const navLabel = (tooltipType) === 'related'
    //   ? <FormattedMessage {...tooltipMessages[elementType].label} />
    //   : <FormattedMessage {...messages.headers.measurement} />;
    let icon = null;
    let navLabelMessage = null;
    switch(elementType){
        case 'Meal':
        case 'food':
            icon = /*#__PURE__*/ _jsx(MealIcon, {});
            navLabelMessage = tooltipMessages.meal.label;
            break;
        case 'Activity':
        case 'activity':
            icon = /*#__PURE__*/ _jsx(ActivityIcon, {});
            navLabelMessage = tooltipMessages.activity.label;
            break;
        case 'HbA1C':
            icon = /*#__PURE__*/ _jsx(MeasurementIcon, {});
            navLabelMessage = 'HbA1C';
            break;
        case 'Medication':
            if (element.bolusFlag || element.basalFlag) {
                icon = /*#__PURE__*/ _jsx(InjectionIcon, {});
                navLabelMessage = tooltipMessages.injection.label;
            } else {
                icon = /*#__PURE__*/ _jsx(PillsIcon, {});
                navLabelMessage = tooltipMessages.pill.label;
            }
            break;
        case 'Note':
            icon = /*#__PURE__*/ _jsx(NoteIcon, {});
            navLabelMessage = tooltipMessages.note.label;
            break;
        case 'injection':
            icon = /*#__PURE__*/ _jsx(InjectionIcon, {});
            navLabelMessage = tooltipMessages.injection.label;
            break;
        case 'pill':
            icon = /*#__PURE__*/ _jsx(PillsIcon, {});
            navLabelMessage = tooltipMessages.pill.label;
            break;
        default:
            icon = null;
    }
    let navLabel = null;
    if (navLabelMessage) {
        if (typeof navLabelMessage === 'string') {
            navLabel = navLabelMessage;
        } else {
            navLabel = /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, navLabelMessage));
        }
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: icon
            }),
            navLabel
        ]
    });
};
